<template>
    <ul class="page" v-if="pageCount > 1">
        <li class="page-item" :class="{'page-disabled':currentPage === 1}" @click="prevPage"><a v-html="prevText"></a></li>
        <li class="page-item" :class="{'page-current':currentPage === 1}" @click="setCurrentPage(1)">
            <a>1</a>
        </li>
        <li class="page-item page-disabled" v-if="currentPage - 3 > 1">
            <a>...</a>
        </li>
        <li class="page-item" v-if="currentPage - 2 > 1" @click="setCurrentPage(currentPage - 2)">
            <a>{{currentPage - 2}}</a>
        </li>
        <li class="page-item" v-if="currentPage - 1 > 1" @click="setCurrentPage(currentPage - 1)">
            <a>{{currentPage - 1}}</a>
        </li>
        <li class="page-item page-current" v-if="currentPage!=1 && currentPage!=pageCount"
            @click="setCurrentPage(currentPage)">
            <a>{{currentPage}}</a>
        </li>
        <li class="page-item" v-if="currentPage + 1 < pageCount" @click="setCurrentPage(currentPage + 1)">
            <a>{{currentPage + 1}}</a>
        </li>
        <li class="page-item" v-if="currentPage + 2 < pageCount" @click="setCurrentPage(currentPage + 2)">
            <a>{{currentPage + 2}}</a>
        </li>

        <li class="page-item page-disabled" v-if="currentPage + 3 < pageCount">
            <a>...</a>
        </li>

        <li class="page-item" :class="{'page-current':currentPage === pageCount}" @click="setCurrentPage(pageCount)">
            <a>{{pageCount}}</a>
        </li>
        <li class="page-item" :class="{'page-disabled':currentPage === pageCount}" @click="nextPage"><a v-html="nextText"></a></li>
    </ul>
</template>
<script>

    export default {
        data () {
            return {
                currentPage: this.current
            }
        },
        props: {
            total: Number,
            current: {
                type: Number,
                default: 1
            },
            length: {
                type: Number,
                default: 10
            },
            prevText: {
                type: String,
                default: '&lt;'
            },
            nextText: {
                type: String,
                default: '&gt;'
            }
        },
        methods: {
            prevPage () {
                if (this.currentPage === 1) {
                    return false
                }
                this.setCurrentPage(this.currentPage - 1)
            },
            nextPage () {
                if (this.currentPage === this.pageCount) {
                    return false
                }
                this.setCurrentPage(this.currentPage + 1)
            },
            setCurrentPage (page) {
                this.currentPage = page
                this.$emit('on-change', page)
            }
        },
        computed: {
            pageCount () {
                const allPage = Math.ceil(this.total / this.length)
                console.log(allPage)
                return (allPage === 0) ? 1 : allPage
            }
        }
    }
</script>
<style scoped lang="scss">
    ul {
        list-style: none;
    }

    .page {
        .page-item {
            display: inline-block;
            vertical-align: middle;
            min-width: 32px;
            height: 32px;
            line-height: 30px;
            margin-right: 4px;
            text-align: center;
            list-style: none;
            background-color: #fff;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            cursor: pointer;
            border: 1px solid #dddee1;
            border-radius: 4px;
            transition: border .2s ease-in-out, color .2s ease-in-out;
            &.page-disabled {
                cursor: not-allowed;
                a {
                    color: #dddee1;
                }
                &:hover {
                    border-color: #dddee1;
                }
            }
            &.page-current {
                background-color: #2d8cf0;
                border-color: #2d8cf0;
                a {
                    color: white;
                }
            }
            &:hover {
                border-color: #2d8cf0
            }
            a {
                margin: 0 6px;
                text-decoration: none;
                color: #495060
            }
        }
    }

</style>



// WEBPACK FOOTER //
// Page.vue?8ca4c50c